export default __webpack_public_path__ + "static/media/fpb60030.4acb5441.png";